import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getInsightsRouteRedirectTarget,
  normalizePathnameForInsightsGuard,
} from '../../helpers/user/insightsRoleAccess';

/**
 * Keeps users with the insights role on allowed paths only (Insights dashboard + auth pages).
 * Client-side only; API remains the source of truth for authorization.
 */
function InsightsRouteGuard({ currentUser, needsLogin }) {
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname || '';

  useEffect(() => {
    const target = getInsightsRouteRedirectTarget({
      needsLogin,
      currentUser,
      pathname,
    });
    if (!target) {
      return;
    }
    const normalizedCurrent = normalizePathnameForInsightsGuard(pathname);
    const normalizedTarget = normalizePathnameForInsightsGuard(target);
    if (normalizedCurrent === normalizedTarget) {
      return;
    }
    history.replace(target);
  }, [needsLogin, pathname, history, currentUser]);

  return null;
}

const mapStateToProps = state => ({
  currentUser: state.new_users.currentUser,
  needsLogin: state.main.needsLogin,
});

export default connect(mapStateToProps)(InsightsRouteGuard);



// WEBPACK FOOTER //
// ./src/components/InsightsRouteGuard/index.js